import React from "react";
import styles from "./loading.module.scss";

function HeadlessLoading(props) {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.comment} ${styles.br} ${styles.animate} ${styles.w80}`} />
      <div className={`${styles.comment} ${styles.br} ${styles.animate} ${styles.w80}`} />
      <div className={`${styles.comment} ${styles.br} ${styles.animate} ${styles.w80}`} />
    </div>
  );
}

function JustLinesLoading(props) {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.comment} ${styles.br} ${styles.animate}`} style={{ marginBottom: "20px" }} />
      <div className={`${styles.comment} ${styles.br} ${styles.animate}`} />
      <div className={`${styles.comment} ${styles.br} ${styles.animate}`} />
    </div>
  );
}

function RegularLoading(props) {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.profilePic} ${styles.din} ${styles.animate}`} />
      <div className={`${styles.comment} ${styles.br} ${styles.animate} ${styles.w80}`}  />
      <div className={`${styles.comment} ${styles.br} ${styles.animate}`} />
      <div className={`${styles.comment} ${styles.br} ${styles.animate}`} />
    </div>
  );
}

function SquareLoading(props) {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.square} ${styles.animate}`} />
    </div>
  );
}

function LoadingLine(props) {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.comment} ${styles.br} ${styles.animate}`} />
    </div>
  );
}

function Loading(props) {
  if (props.isJustLines) {
    return <JustLinesLoading />;
  }
  if (props.isSquare) {
    return <SquareLoading />;
  }
  if (props.hasHead) {
    return <RegularLoading />;
  }
  if (props.isLine) {
    return <LoadingLine />;
  }
  return <HeadlessLoading />;
}

export default Loading;